import { Locale } from 'vue-i18n';
import { extend } from 'vee-validate';
import { required, email, max } from 'vee-validate/dist/rules';
// @ts-ignore
import i18n from './../plugins/i18n.ts';

export const initializeValidators: (language: Locale) => void = language => {
  extend('required', {
    ...required,
    message: i18n.t('VALIDATION.ERROR.REQUIRED', language).toString(),
  });

  extend('email', {
    ...email,
    message: i18n.t('VALIDATION.ERROR.MAIL', language).toString(),
  });

  extend('isTrue', {
    ...required,
    message: i18n.t('VALIDATION.ERROR.MUST_BE_CHECKED', language).toString(),
  });

  extend('uid', {
    validate: value => new RegExp('^CHE-\\d{3}\\.\\d{3}\\.\\d{3}$').test(value),
    message: i18n.t('VALIDATION.ERROR.UID', language).toString(),
  });

  extend('max', {
    ...max,
    message: i18n.t('VALIDATION.ERROR.MAX', language).toString(),
  });
};
